var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 20,
    fill: "none",
    viewBox: "0 0 4 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M2 4.375C3.03553 4.375 3.875 3.53553 3.875 2.5C3.875 1.46447 3.03553 0.625 2 0.625C0.964466 0.625 0.125 1.46447 0.125 2.5C0.125 3.53553 0.964466 4.375 2 4.375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M2 11.875C3.03553 11.875 3.875 11.0355 3.875 10C3.875 8.96447 3.03553 8.125 2 8.125C0.964466 8.125 0.125 8.96447 0.125 10C0.125 11.0355 0.964466 11.875 2 11.875Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M2 19.375C3.03553 19.375 3.875 18.5355 3.875 17.5C3.875 16.4645 3.03553 15.625 2 15.625C0.964466 15.625 0.125 16.4645 0.125 17.5C0.125 18.5355 0.964466 19.375 2 19.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.b097d72988ef151a01303477709639a0.svg";
export { ForwardRef as ReactComponent };